export default "__VITE_ASSET__64cba0fd__"